class CollectionLoader {
  constructor() {
    this.collectionContainer = document.getElementById('collection-products-container');
    this.tabsContainer = document.querySelector('.swiper-tabs');
    this.init();
  }

  /**
   * Updates the destination element's innerHTML and attributes from the source element in the new HTML.
   * @param {string} selector - CSS selector for the element to update (e.g., '#collection-products-container')
   * @param {Document} newDoc - The parsed HTML document from the fetch response
   */
  updateDom(selector, newDoc) {
    const destination = document.querySelector(selector);
    const source = newDoc.querySelector(selector);
    if (source && destination) {
      destination.innerHTML = source.innerHTML;
      [...source.attributes].forEach(attr => destination.setAttribute(attr.name, attr.value));
    }
  }

  createLoadingOverlay(element) {
    if (element.querySelector('.loading-overlay')) return;
    const overlay = document.createElement('div');
    overlay.className = 'loading-overlay absolute inset-0 w-full h-full bg-gray-500/10 backdrop-blur-sm flex items-center justify-center z-10';
    const spinner = document.createElement('div');
    spinner.className = 'loading-spinner w-10 h-10 border-4 border-gray-200 border-t-blue-500 rounded-full animate-spin';
    overlay.appendChild(spinner);
    element.appendChild(overlay);
    return overlay;
  }

  reinitializeFAQs() {
    const faqContainer = document.querySelector('[data-faq-container]');
    if (faqContainer) {
      new FAQManager(faqContainer);
    }
  }

  async loadCollection(url, updateUrl = true) {
    const financingBanner = document.getElementById('section-financing-banner');
    const theOnlyBanner = document.getElementById('section-the-only-banner');
    const faqAnimatedSection = document.getElementById('section-faq-animated');
    const originalCollectionHeight = this.collectionContainer.offsetHeight;
    const originalFinancingHeight = financingBanner?.offsetHeight;
    const originalTheOnlyHeight = theOnlyBanner?.offsetHeight;
    const originalFaqAnimatedHeight = faqAnimatedSection?.offsetHeight;

    const overlays = [
      [this.collectionContainer, null],
      [financingBanner, null],
      [theOnlyBanner, null],
      [faqAnimatedSection, null],
    ];
    overlays.forEach(([el], i) => {
      if (el) overlays[i][1] = this.createLoadingOverlay(el);
    });

    try {
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Network response was not ok');
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      this.updateDom('#collection-products-container', doc);
      this.updateDom('#section-financing-banner', doc);
      this.updateDom('#section-the-only-banner', doc);
      this.updateDom('#section-faq-animated', doc);

      // Reinitialize FAQs after content is loaded
      this.reinitializeFAQs();

      // Restart hero/lazy videos in the swapped-in sections: inline <script>
      // tags inside innerHTML never execute, and the banner videos ship
      // without an autoplay attribute (preload="none"), so without this the
      // new collection's banner video stays paused.
      if (window.initBannerVideos) window.initBannerVideos();
      if (window.initLazyAutoplayVideos) window.initLazyAutoplayVideos();

      overlays.forEach(([_, overlay]) => overlay?.remove());
      if (updateUrl) window.history.pushState({ path: url }, '', url);
    } catch (error) {
      console.error('Error loading collection:', error);
      overlays.forEach(([el, overlay], i) => overlay?.remove());
      this.collectionContainer.innerHTML = `
        <div class="text-center py-8 text-red-500" style="min-height: ${originalCollectionHeight}px">
          Error loading collection. Please try again.
        </div>
      `;
      if (financingBanner) financingBanner.innerHTML = `<div class="text-center py-4 text-red-500" style="min-height: ${originalFinancingHeight}px">Error loading content. Please try again.</div>`;
      if (theOnlyBanner) theOnlyBanner.innerHTML = `<div class="text-center py-4 text-red-500" style="min-height: ${originalTheOnlyHeight}px">Error loading content. Please try again.</div>`;
      if (faqAnimatedSection) faqAnimatedSection.innerHTML = `<div class="text-center py-4 text-red-500" style="min-height: ${originalFaqAnimatedHeight}px">Error loading content. Please try again.</div>`;
    }
  }

  setActiveTab(target) {
    if (!target) return;
    this.tabsContainer.querySelectorAll('div').forEach(div => {
      div.classList.remove('active', '[&.active]:bg-black', '[&.active]:text-[#CCCCCC]');
    });
    target.classList.add('active', '[&.active]:bg-black', '[&.active]:text-[#CCCCCC]');
  }

  init() {
    if (this.tabsContainer) {
      this.tabsContainer.addEventListener('click', async (e) => {
        const link = e.target.closest('.collection-filter-link');
        if (!link) return;
        e.preventDefault();
        const parentDiv = link.closest('div');
        this.setActiveTab(parentDiv);
        const collectionUrl = link.getAttribute('data-collection-url');
        await this.loadCollection(collectionUrl);
      });
    }

    window.addEventListener('popstate', (event) => {
      if (event.state?.path) {
        this.loadCollection(event.state.path, false);
      }
    });

    const currentPath = window.location.pathname;
    const activeLink = document.querySelector(`.collection-filter-link[data-collection-url="${currentPath}"]`);
    if (activeLink) {
      const parentDiv = activeLink.closest('div');
      this.setActiveTab(parentDiv);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CollectionLoader();
}); 